'use strict';

var _ = require('lodash');
var GridFaresSaveButtonController = function GridFaresSaveButtonController($scope) {
  var gridPanel = $scope.gridPanelScope;
  function hasRowModification(row) {
    if (!row._old) {
      // no modificatons in grid for this row
      return false;
    }
    // check if user modified undefined to null
    var isOldUserFareUndefined = $scope.averageFaresGridState ? row._old.userFare === undefined || row._old.userFare === null : row._old.userMappedFare === undefined || row._old.userMappedFare === null;
    var userValue = $scope.averageFaresGridState ? row.userFare !== null : row.userMappedFare !== null;
    return !isOldUserFareUndefined || userValue;
  }
  $scope.saveChanges = function () {
    save(false);
  };
  $scope.$on('fares-average-data-grid:saveSuccess', function () {
    gridPanel.clearModifiedCells();
  });
  $scope.$on('save-modal:fares-recordChanges', function () {
    save(true);
  });
  function save(inModal) {
    var rows = _.chain(gridPanel.jqxGridSettings.source.loadedData).filter(hasRowModification).clone(true).value(true);
    if (rows.length > 0) {
      if (inModal) {
        $scope.$emit('fares-average-data-grid:saveChanges', rows, 'inModal');
      } else {
        $scope.$emit('fares-average-data-grid:saveChanges', rows);
      }
    } else {
      gridPanel.clearModifiedCells();
    }
  }
};
GridFaresSaveButtonController.$inject = ['$scope'];
module.exports = GridFaresSaveButtonController;